export const ERROR = 'error';
export const WARNING = 'warning';
export const SUCCESS = 'success';
export const SUCCESS_LOGIN = 'success_login';
export const INFO = 'info';
export const CLOSE_NOTIFICATION = 'close_notification';

export const PUSH_ERROR = 'set_error';
export const CLEAR_ERRORS = 'clear_errors';

export const OPEN_BACKDROP = 'open_backdrop';
export const CLOSE_BACKDROP = 'close_backdrop';

export const FETCH_DEVICES = 'fetch_devices';
export const FETCH_ASSIGNED_DEVICES = 'fetch_assigned_devices';
export const CLEAR_ASSIGNED_DEVICES = 'clear_assigned_devices';
export const FETCH_SHIPMENT_DETAILS = 'fetch_devices_details';
export const FETCH_DEVICES_SETTINGS = 'fetch_devices_settings';
export const CLEAR_DEVICE_DASHBOARD_DATA = 'clear_device_dashboard_data';

export const FETCH_DEVICE = 'fetch_device';
export const FETCH_DEVICE_EVENTS = 'fetch_device_events';
export const FETCH_DEVICE_EVENTS_AND_LOGS = 'fetch_device_events_and_logs';
export const CLEAR_DEVICE = 'clear_device';

export const DEVICE_DETAILS_FETCH_STARTED = 'device_details_fetch_started';
export const DEVICE_DETAILS_FETCH_SUCCEEDED = 'device_details_fetch_succeeded';
export const DEVICE_DETAILS_FETCH_FAILED = 'device_details_fetch_failed';
export const DEVICE_DETAILS_CLEAR = 'device_details_clear';

export const DEVICES_PAGINATED_FETCH_STARTED = 'devices_paginated_fetch_started';
export const DEVICES_PAGINATED_FETCH_SUCCEEDED = 'devices_paginated_fetch_succeeded';
export const DEVICES_PAGINATED_FETCH_FAILED = 'devices_paginated_fetch_failed';
export const DEVICES_PAGINATED_CHANGE_PAGE = 'devices_paginated_change_page';
export const DEVICES_PAGINATED_CHANGE_ITEMS_PER_PAGE = 'devices_paginated_change_items_per_page';
export const DEVICES_PAGINATED_CHANGE_ORDER = 'devices_paginated_change_order';
export const DEVICES_PAGINATED_CHANGE_ORDER_BY = 'devices_paginated_change_order_by';
export const DEVICES_PAGINATED_CHANGE_ORDER_AND_ORDER_BY = 'devices_paginated_change_order_and_order_by';
export const DEVICES_PAGINATED_SET_FILTER = 'devices_paginated_set_filter';
export const DEVICES_PAGINATED_SET_ASSIGNED_STATUS = 'devices_paginated_set_assigned_status';
export const DEVICES_PAGINATED_CLEAR = 'devices_paginated_clear';

export const DEVICES_FILTER_FETCH_STARTED = 'devices_filter_fetch_started';
export const DEVICES_FILTER_FETCH_SUCCEEDED = 'devices_filter_fetch_succeeded';
export const DEVICES_FILTER_FETCH_FAILED = 'devices_filter_fetch_failed';
export const DEVICES_FILTER_CLEAR = 'devices_filter_clear';
export const DEVICES_FILTER_SET_FILTER = 'devices_filter_set_filter';
export const DEVICES_FILTER_SELECTED_DATA_FETCH_SUCCEEDED = 'device_filter_selected_data_fetch_filter';

export const DEVICES_LAST_LOCATIONS_FETCH_STARTED = 'devices_last_locations_fetch_started';
export const DEVICES_LAST_LOCATIONS_FETCH_SUCCEED = 'devices_last_locations_fetch_succeed';
export const DEVICES_LAST_LOCATIONS_FETCH_FAILED = 'devices_last_locations_fetch_failed';
export const DEVICES_LAST_LOCATIONS_CLEAR = 'devices_last_locations_clear';

export const DEVICES_AVAILABLE_FETCH_STARTED = 'devices_available_fetch_started';
export const DEVICES_AVAILABLE_FETCH_SUCCEEDED = 'devices_available_fetch_succeeded';
export const DEVICES_AVAILABLE_FETCH_FAILED = 'devices_available_fetch_failed';
export const DEVICES_AVAILABLE_CLEAR = 'devices_available_clear';

export const FETCH_DEVICE_LOGS = 'fetch_device_logs';
export const FETCH_DEVICE_LOGS_STARTED = 'fetch_device_logs_started';
export const FETCH_DEVICE_LOGS_FAILED = 'fetch_device_logs_failed';
export const DEVICE_LOGS_PAGINATED_CHANGE_PAGE = 'device_logs_paginated_change_page';
export const DEVICE_LOGS_CHANGE_ORDER = 'device_logs_change_order';
export const DEVICE_LOGS_SET_FILTER = 'device_logs_set_filter';
export const DEVICE_LOGS_SET_PERIOD = 'device_logs_set_period';
export const DEVICE_LOGS_CLEAR = 'device_logs_clear';

export const FETCH_USER = 'fetch_user';
export const UPDATE_USER_SETTINGS = 'update_user_settings';
export const FETCH_USERS = 'fetch_users';
export const CLEAR_USERS = 'clear_users';
export const CLEAR_USER_DATA = 'clear_user_data';

export const USERS_PAGINATED_FETCH_STARTED = 'users_paginated_fetch_started';
export const USERS_PAGINATED_FETCH_SUCCEEDED = 'users_paginated_fetch_succeeded';
export const USERS_PAGINATED_FETCH_FAILED = 'users_paginated_fetch_failed';
export const USERS_PAGINATED_CHANGE_PAGE = 'users_paginated_change_page';
export const USERS_PAGINATED_CHANGE_ITEMS_PER_PAGE = 'users_paginated_change_items_per_page';
export const USERS_PAGINATED_CHANGE_ORDER = 'users_paginated_change_order';
export const USERS_PAGINATED_CHANGE_ORDER_BY = 'users_paginated_change_order_by';
export const USERS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY = 'users_paginated_change_order_and_order_by';
export const USERS_PAGINATED_SET_FILTER = 'users_paginated_set_filter';
export const USERS_PAGINATED_CLEAR = 'users_paginated_clear';
export const USERS_PAGINATED_TOGGLE_INACTIVE = 'users_paginated_toggle_inactive';

export const USERS_WITHOUT_PROJECTS_FETCH_STARTED = 'users_without_projects_fetch_started';
export const USERS_WITHOUT_PROJECTS_FETCH_SUCCEEDED = 'users_without_projects_fetch_succeeded';
export const USERS_WITHOUT_PROJECTS_FETCH_FAILED = 'users_without_projects_fetch_failed';
export const USERS_WITHOUT_PROJECTS_CLEAR = 'users_without_projects_clear';

export const USERS_BY_PROJECT_FETCH_STARTED = 'users_by_project_fetch_started';
export const USERS_BY_PROJECT_FETCH_SUCCEEDED = 'users_by_project_fetch_succeeded';
export const USERS_BY_PROJECT_FETCH_FAILED = 'users_by_project_fetch_failed';
export const USERS_BY_PROJECT_CLEAR = 'users_by_project_clear';

export const USERS_FILTER_FETCH_STARTED = 'users_filter_fetch_started';
export const USERS_FILTER_FETCH_SUCCEEDED = 'users_filter_fetch_succeeded';
export const USERS_FILTER_FETCH_FAILED = 'users_filter_fetch_failed';
export const USERS_FILTER_SET_FILTER = 'users_filter_set_filter';
export const USERS_FILTER_SELECTED_DATA_FETCH_SUCCEEDED = 'users_filter_selected_data_fetch_filter';
export const USERS_FILTER_CLEAR = 'users_filter_clear';

export const FETCH_USER_LOGS = 'fetch_user_logs';
export const FETCH_USER_LOGS_STARTED = 'fetch_user_logs_started';
export const FETCH_USER_LOGS_FAILED = 'fetch_user_logs_failed';
export const USER_LOGS_PAGINATED_CHANGE_PAGE = 'user_logs_paginated_change_page';
export const USER_LOGS_CHANGE_ORDER = 'user_logs_change_order';
export const USER_LOGS_SET_FILTER = 'user_logs_set_filter';
export const USER_LOGS_SET_PERIOD = 'user_logs_set_period';
export const USER_LOGS_CLEAR = 'user_logs_clear';

export const USER_SELECT_FETCH_STARTED = 'user_select_fetch_started';
export const USER_SELECT_FETCH_SUCCEEDED = 'user_select_fetch_succeeded';
export const USER_SELECT_FETCH_FAILED = 'user_select_fetch_failed';
export const USER_SELECT_CLEAR = 'user_select_clear';

export const USER_POPUP_FETCH_STARTED = 'user_popup_fetch_started';
export const USER_POPUP_FETCH_SUCCEEDED = 'user_popup_fetch_succeeded';
export const USER_POPUP_FETCH_FAILED = 'user_popup_fetch_failed';
export const USER_POPUP_CHANGE_PAGE = 'user_popup_change_page';
export const USER_POPUP_SET_FILTER = 'user_popup_set_filter';
export const USER_POPUP_CLEAR = 'user_popup_clear';
export const USER_POPUP_OPEN_POPUP = 'user_popup_open_popup';

export const USER_NOTIFICATION_FETCH_STARTED = 'user_notification_fetch_started';
export const USER_NOTIFICATION_FETCH_SUCCEEDED = 'user_notification_fetch_succeeded';
export const USER_NOTIFICATION_READ = 'user_notification_read';
export const USER_NOTIFICATION_DELETE = 'user_notification_delete';
export const USER_NOTIFICATION_FETCH_FAILED = 'user_notification_fetch_failed';
export const USER_NOTIFICATION_CLEAR = 'user_notification_clear';
export const USER_NOTIFICATION_COUNT_FETCH_STARTED = 'user_notification_count_fetch_started';
export const USER_NOTIFICATION_COUNT_FETCH_SUCCEEDED = 'user_notification_count_fetch_succeeded';

export const FETCH_ACCOUNT = 'fetch_account';
export const FETCH_ACCOUNT_STARTED = 'fetch_account_started';
export const FETCH_ACCOUNT_SUCCEEDED = 'fetch_account_succeeded';
export const FETCH_ACCOUNT_FAILED = 'fetch_account_failed';
export const FETCH_ACCOUNT_FAILED_UNAUTHORIZED = 'fetch_account_failed_unauthorized';
export const PATCH_ACCOUNT_TIME_ZONE = 'patch_account_time_zone';

export const UPDATE_BREADCRUMB = 'update_breadcrumb';
export const FETCH_MEASUREMENTS = 'fetch_measurements';
export const FETCH_METRICS_BY_IDENTIFIER = 'fetch_metrics_by_identifier';
export const FETCH_MEASUREMENTS_POINTS = 'fetch_measurements_points';
export const CLEAR_METRICS = 'clear_metrics';
export const CLEAR_MEASUREMENTS = 'clear_measurements';

export const FETCH_LOCATIONS = 'fetch_locations';

export const FETCH_PROJECTS = 'fetch_projects';
export const FETCH_PROJECTS_STARTED = 'fetch_projects_started';
export const FETCH_PROJECTS_USERS_DEVICES = 'fetch_projects_users_devices';
export const CLEAR_PROJECT_DATA = 'clear_project_data';
export const FETCH_PROJECT_USERS = 'fetch_projects_user';
export const FETCH_PROJECT_DEVICES = 'fetch_projects_device';
export const FETCH_PROJECT_ALERTS = 'fetch_projects_alerts';
export const CLEAR_PROJECT_ALERTS = 'clear_project_alerts';
export const FETCH_PROJECT_ALERTS_CONFIRMATIONS = 'fetch_projects_alerts_confirmations';
export const CLEAR_PROJECT_ALERTS_CONFIRMATIONS = 'clear_projects_alerts_confirmations';
export const FETCH_PROJECT_PRODUCTS = 'fetch_projects_products';
export const FETCH_PROJECT_PACKAGES = 'fetch_projects_packages';
export const FETCH_PROJECTS_LOGS = 'fetch_projects_logs';
export const FETCH_PROJECTS_LOGS_STARTED = 'fetch_projects_logs_started';
export const FETCH_PROJECTS_LOGS_FAILED = 'fetch_projects_logs_failed';

export const FETCH_PROJECT_CUSTOM_FIELD_STARTED = 'fetch_project_custom_field_started';
export const FETCH_PROJECT_CUSTOM_FIELD_SUCCEEDED = 'fetch_project_custom_field_succeeded';
export const FETCH_PROJECT_CUSTOM_FIELD_FAILED = 'fetch_project_custom_field_failed';
export const FETCH_PROJECT_CUSTOM_FIELD_CLEAR = 'fetch_project_custom_field_clear';

export const PROJECTS_LOGS_PAGINATED_CHANGE_PAGE = 'projects_logs_paginated_change_page';
export const PROJECTS_LOGS_CHANGE_ORDER = 'projects_logs_change_order';
export const PROJECTS_LOGS_SET_FILTER = 'projects_logs_set_filter';
export const PROJECTS_LOGS_SET_PERIOD = 'projects_logs_set_period';
export const PROJECTS_LOGS_CLEAR = 'projects_logs_clear';

export const PROJECTS_PAGINATED_FETCH_STARTED = 'projects_paginated_fetch_started';
export const PROJECTS_PAGINATED_FETCH_SUCCEEDED = 'projects_paginated_fetch_succeeded';
export const PROJECTS_PAGINATED_FETCH_FAILED = 'projects_paginated_fetch_failed';
export const PROJECTS_PAGINATED_CHANGE_PAGE = 'projects_paginated_change_page';
export const PROJECTS_PAGINATED_CHANGE_ITEMS_PER_PAGE = 'projects_paginated_change_items_per_page';
export const PROJECTS_PAGINATED_CHANGE_ORDER = 'projects_paginated_change_order';
export const PROJECTS_PAGINATED_CHANGE_ORDER_BY = 'projects_paginated_change_order_by';
export const PROJECTS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY = 'projects_paginated_change_order_and_order_by';
export const PROJECTS_PAGINATED_SET_FILTER = 'projects_paginated_set_filter';
export const PROJECTS_PAGINATED_TOGGLE_EXPIRIED = 'projects_paginated_toggle_expiried';
export const PROJECTS_PAGINATED_CLEAR = 'projects_paginated_clear';
export const PROJECTS_PAGINATED_SET_PROJECT_DEVICE = 'projects_paginated_set_project_device';
export const PROJECTS_PAGINATED_REMOVE_PROJECT_DEVICE = 'projects_paginated_remove_project_device';

export const PROJECTS_FILTER_FETCH_STARTED = 'projects_filter_fetch_started';
export const PROJECTS_FILTER_FETCH_SUCCEEDED = 'projects_filter_fetch_succeeded';
export const PROJECTS_FILTER_FETCH_FAILED = 'projects_filter_fetch_failed';
export const PROJECTS_FILTER_SET_FILTER = 'projects_filter_set_filter';
export const PROJECTS_FILTER_SELECTED_DATA_FETCH_SUCCEEDED = 'project_filter_selected_data_fetch_filter';
export const PROJECTS_FILTER_CLEAR = 'projects_filter_clear';

export const PROJECT_DEVICES_FETCH_STARTED = 'project_devices_fetch_started';
export const PROJECT_DEVICES_FETCH_SUCCEEDED = 'project_devices_fetch_succeeded';
export const PROJECT_DEVICES_FETCH_FAILED = 'project_devices_fetch_failed';
export const PROJECT_DEVICES_CHANGE_PAGE = 'project_devices_change_page';
export const PROJECT_DEVICES_CHANGE_ITEMS_PER_PAGE = 'project_devices_change_items_per_page';
export const PROJECT_DEVICES_CHANGE_ORDER = 'project_devices_change_order';
export const PROJECT_DEVICES_CHANGE_ORDER_BY = 'project_devices_change_order_by';
export const PROJECT_DEVICES_CHANGE_ORDER_AND_ORDER_BY = 'project_devices_change_order_and_order_by';
export const PROJECT_DEVICES_SET_FILTER = 'project_devices_set_filter';
export const PROJECT_DEVICES_SET_DEVICE_TYPE = 'project_devices_set_device_type';
export const PROJECT_DEVICES_CLEAR = 'project_devices_clear';
export const OPEN_PROJECT_DEVICES_POPUP = 'open_project_devices_popup';
export const PROJECT_DEVICES_POPUP_SET_ADD_MODE = 'project_devices_popup_set_add_mode';
export const PROJECT_DEVICES_SET_FORM_DEVICES = 'project_devices_popup_set_form_devices';
export const PROJECT_DEVICES_POPUP_PROJECT_FETCH_STARTED = 'project_devices_poup_project_fetch_started';
export const PROJECT_DEVICES_POPUP_PROJECT_FETCH_SUCCEEDED = 'project_devices_poup_project_fetch_succeeded';
export const PROJECT_DEVICES_POPUP_PROJECT_FETCH_FAILED = 'project_devices_poup_project_fetch_failed';
export const PROJECT_DEVICES_POPUP_SET_REMOVED_DEVICES = 'project_devices_popup_set_removed_devices';
export const PROJECT_DEVICES_POPUP_SET_ADDED_DEVICES = 'project_devices_popup_set_added_devices';
export const PROJECT_DEVICES_POPUP_SET_STATE_CHANGED = 'project_devices_popup_set_popup_state_changed';
export const PROJECT_DEVICES_POPUP_SET_STATE_DIFF = 'project_devices_popup_set_popup_state_diff';
export const PROJECT_DEVICES_POPUP_TOGGLE_DEVICE_ALERT = 'project_devices_popup_toggle_device_alert';
export const PROJECT_DEVICES_POPUP_TOGGLE_ALL_DEVICES_ALERT = 'project_device_popup_toggle_all_device_alerts';
export const PROJECT_DEVICES_POPUP_SET_DEVICE_ALERT = 'project_devices_popup_set_device_alert';

export const PROJECT_SELECT_FETCH_STARTED = 'project_select_fetch_started';
export const PROJECT_SELECT_FETCH_SUCCEEDED = 'project_select_fetch_succeeded';
export const PROJECT_SELECT_FETCH_FAILED = 'project_select_fetch_failed';
export const PROJECT_SELECT_CLEAR = 'project_select_clear';

export const SHIPMENTS_PAGINATED_FETCH_STARTED = 'shipments_paginated_fetch_started';
export const SHIPMENTS_PAGINATED_FETCH_SUCCEEDED = 'shipments_paginated_fetch_succeeded';
export const SHIPMENTS_PAGINATED_FETCH_FAILED = 'shipments_paginated_fetch_failed';
export const SHIPMENTS_PAGINATED_CHANGE_PAGE = 'shipments_paginated_change_page';
export const SHIPMENTS_PAGINATED_CHANGE_ITEMS_PER_PAGE = 'shipments_paginated_change_items_per_page';
export const SHIPMENTS_PAGINATED_CHANGE_ORDER = 'shipments_paginated_change_order';
export const SHIPMENTS_PAGINATED_CHANGE_ORDER_BY = 'shipments_paginated_change_order_by';
export const SHIPMENTS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY = 'shipments_paginated_change_order_and_order_by';
export const SHIPMENTS_PAGINATED_SET_FILTER = 'shipments_paginated_set_filter';
export const SHIPMENTS_PAGINATED_CLEAR = 'shipments_paginated_clear';

export const SHIPMENTS_FILTER_FETCH_STARTED = 'shipments_filter_fetch_started';
export const SHIPMENTS_FILTER_FETCH_SUCCEEDED = 'shipments_filter_fetch_succeeded';
export const SHIPMENTS_FILTER_FETCH_FAILED = 'shipments_filter_fetch_failed';
export const SHIPMENTS_FILTER_CLEAR = 'shipments_filter_clear';
export const SHIPMENTS_FILTER_SET_FILTER = 'shipments_filter_set_filter';
export const SHIPMENTS_FILTER_SELECTED_DATA_FETCH_SUCCEEDED = 'shipments_filter_selected_data_fetch_filter';

export const FETCH_SHIPMENT_LOGS = 'fetch_shipment_logs';
export const FETCH_SHIPMENT_LOGS_STARTED = 'fetch_shipment_logs_started';
export const FETCH_SHIPMENT_LOGS_FAILED = 'fetch_shipment_logs_failed';
export const SHIPMENT_LOGS_PAGINATED_CHANGE_PAGE = 'shipment_logs_paginated_change_page';
export const SHIPMENT_LOGS_CHANGE_ORDER = 'shipment_logs_change_order';
export const SHIPMENT_LOGS_SET_FILTER = 'shipment_logs_set_filter';
export const SHIPMENT_LOGS_SET_PERIOD = 'shipment_logs_set_period';
export const SHIPMENT_LOGS_CLEAR = 'shipment_logs_clear';

export const FETCH_SHIPMENT_PROJECTS = 'fetch_shipment_projects';
export const FETCH_SHIPMENT_DATA_STARTED = 'fetch_shipment_started';
export const FETCH_SHIPMENT = 'fetch_shipment';
export const CLEAR_SHIPMENT = 'clear_shipment';
export const FETCH_SHIPMENT_FAILED = 'fetch_shipment_failed';
export const FETCH_SHIPMENT_EVENTS = 'fetch_shipment_events';
export const FETCH_SHIPMENT_LOCATIONS = 'fetch_shipment_locations';
export const FETCH_SHIPMENT_DATE = 'fetch_shipment_date';
export const FETCH_SHIPMENT_DELIVERY = 'fetch_shipment_delivery';
export const FETCH_SHIPMENT_GOODS = 'fetch_shipment_goods';
export const FETCH_SHIPMENT_CONTAINERS = 'fetch_shipment_containers';
export const FETCH_SHIPMENT_CARGO = 'fetch_shipment_cargo';
export const STOP_SHIPMENT = 'stop_shipment';
export const FETCH_SHIPMENT_METRICS_BY_IDENTIFIER = 'fetch_shipment_metrics_by_identifier';
export const FETCH_SHIPMENT_METRICS_BY_IDENTIFIER_STARTED = 'fetch_shipment_metrics_by_identifier_started';
export const FETCH_SHIPMENT_METRICS_BY_IDENTIFIER_COMPLETED = 'fetch_shipment_metrics_by_identifier_completed';
export const FETCH_SHIPMENT_AND_LOCATION_STARTED = 'fetch_shipment_and_location_started';
export const FETCH_SHIPMENT_AND_LOCATION_SUCCEEDED = 'fetch_shipment_and_location_succeeded';
export const FETCH_EVENTS_AND_LOGS_STARTED = 'fetch_events_and_logs_started';
export const FETCH_SHIPMENT_DATA_SUCCEEDED = 'fetch_shipment_succeeded';
export const SET_SHIPMENT_DATA = 'set_shipment_data';
export const SET_COPIED_SHIPMENT = 'set_copied_shipment';
export const SET_COPIED_SHIPMENT_STATUS = 'set_copied_shipment_status';
export const CLEAR_COPIED_SHIPMENT = 'clear_copied_shipment';
export const UPDATE_SHIPMENT_EVENTS = 'update_shipment_events';

export const FETCH_SHIPMENT_FILES = 'fetch_shipment_files';
export const POST_SHIPMENT_FILES = 'post_shipment_files';
export const DELETE_SHIPMENT_FILES = 'delete_shipment_file';

export const FETCH_SHIPMENT_NOTIFICATION_RECIPIENTS = 'fetch_shipment_notification_recipients';

export const FETCH_SHIPMENTS = 'fetch_shipments';
export const FETCH_SHIPMENTS_STARTED = 'fetch_shipments_started';
export const FETCH_SHIPMENTS_SUCCEEDED = 'fetch_shipments_succeeded';
export const FETCH_SHIPMENTS_FAILED = 'fetch_shipments_failed';
export const CLEAR_SHIPMENTS = 'clear_shipments';

export const SET_DISPLAY_FIELDS = 'set_display_fields';
export const CLEAR_DISPLAY_FIELDS = 'clear_display_fields';

export const FETCH_META_DEVICE = 'fetch_meta_device';

export const NEXT_SHIPMENT_STEP = 'next_shipment_step';
export const PREVIOUS_SHIPMENT_STEP = 'previous_shipment_step';
export const GO_TO_SHIPMENT_STEP = 'go_to_shipment_step';
export const SET_AFTER_SUBMIT_ACTION = 'set_after_submit_action';
export const PROCESS_AFTER_SUBMIT_ACTION = 'process_after_submit_action';
export const SET_SHIPMENT_FORM_PRISTINE = 'set_shipment_form_pristine';
export const SET_SHIPMENT = 'set_shipment';
export const SET_DELIVERY = 'set_delivery';
export const SET_SHIPMENT_CARGO = 'set_shipment_cargo';
export const SET_FILES = 'set_files';
export const SET_RECIPIENTS = 'set_recipients';
export const SET_NOTIFICATION_CONTACTS = 'set_notification_contacts';
export const RESET_SHIPMENT_FORM_DATA = 'reset_shipment_form_data';
export const SET_SHIPMENT_FORM_STATUS = 'set_shipment_form_status';
export const SET_JUST_SELECTED_TAB = 'set_just_selected_tab';

export const GO_TO_PROJECT_STEP = 'go_to_project_step';
export const RESET_PROJECT_FORM_DATA = 'reset_project_form_data';

export const GO_TO_APPLIANCE_STEP = 'go_to_appliance_step';
export const SET_APPLIANCE_FORM_PRISTINE = 'set_appliance_form_pristine';
export const SET_APPLIANCE_FORM_VALID = 'set_appliance_form_valid';
export const RESET_APPLIANCE_FORM_DATA = 'reset_appliance_form_data';

export const FETCH_DEEPLINK_SHIPMENT = 'fetch_deeplink_shipment';
export const FETCH_DEEPLINK_SHIPMENT_FILES = 'fetch_deeplink_shipment_files';
export const FETCH_DEEPLINK_SHIPMENT_EVENTS_AND_LOGS = 'fetch_deeplink_shipment_events_and_logs';
export const FETCH_DEEPLINK_SHIPMENT_EVENTS_AND_LOGS_STARTED = 'fetch_deeplink_shipment_events_and_logs_started';
export const FETCH_DEEPLINK_SHIPMENT_EVENTS_AND_LOGS_COMPLETED = 'fetch_deeplink_shipment_events_and_logs_completed';
export const FETCH_DEEPLINK_SHIPMENT_LOCATIONS = 'fetch_deeplink_shipment_locations';
export const FETCH_DEEPLINK_DEVICE_META = 'fetch_deeplink_device_meta';
export const CLEAR_DEEPLINK_SHIPMENT_DATA = 'clear_deeplink_shipment_data';
export const FETCH_DEEPLINK_SHIPMENT_METRICS_BY_IDENTIFIER = 'fetch_deeplink_shipment_metrics_by_identifier';
export const FETCH_DEEPLINK_SHIPMENT_METRICS_BY_IDENTIFIER_STARTED = 'fetch_deeplink_shipment_metrics_by_identifier_started';
export const FETCH_DEEPLINK_SHIPMENT_METRICS_BY_IDENTIFIER_COMPLETED = 'fetch_deeplink_shipment_metrics_by_identifier_completed';

export const ADDRESS_BOOK_CONTACTS_PAGINATED_FETCH_STARTED = 'address_book_contacts_paginated_fetch_started';
export const ADDRESS_BOOK_CONTACTS_PAGINATED_FETCH_SUCCEEDED = 'address_book_contacts_paginated_fetch_succeeded';
export const ADDRESS_BOOK_CONTACTS_PAGINATED_FETCH_FAILED = 'address_book_contacts_paginated_fetch_failed';
export const ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_PAGE = 'address_book_contacts_paginated_change_page';
export const ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ITEMS_PER_PAGE = 'address_book_contacts_paginated_change_items_per_page';
export const ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ORDER = 'address_book_contacts_paginated_change_order';
export const ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ORDER_BY = 'address_book_contacts_paginated_change_order_by';
export const ADDRESS_BOOK_CONTACTS_PAGINATED_CHANGE_ORDER_AND_ORDER_BY = 'address_book_contacts_paginated_change_order_and_order_by';
export const ADDRESS_BOOK_CONTACTS_PAGINATED_SET_FILTER = 'address_book_contacts_paginated_set_filter';
export const ADDRESS_BOOK_CONTACTS_PAGINATED_CLEAR = 'address_book_contacts_paginated_clear';

export const ADDRESS_BOOK_FETCH_STARTED = 'address_book_fetch_started';
export const ADDRESS_BOOK_FETCH_SUCCEEDED = 'address_book_fetch_succeeded';
export const ADDRESS_BOOK_FETCH_FAILED = 'address_book_fetch_failed';
export const ADDRESS_BOOK_CLEAR = 'address_book_clear';

export const ADDRESS_BOOKS_FETCH_STARTED = 'address_books_fetch_started';
export const ADDRESS_BOOKS_FETCH_SUCCEEDED = 'address_books_fetch_succeeded';
export const ADDRESS_BOOKS_FETCH_FAILED = 'address_books_fetch_failed';
export const ADDRESS_BOOKS_CLEAR = 'address_books_clear';

export const ADDRESS_BOOK_CONTACT_FETCH_STARTED = 'address_book_contact_fetch_started';
export const ADDRESS_BOOK_CONTACT_FETCH_SUCCEEDED = 'address_book_contact_fetch_succeeded';
export const ADDRESS_BOOK_CONTACT_FETCH_FAILED = 'address_book_contact_fetch_failed';
export const ADDRESS_BOOK_CONTACT_CLEAR = 'address_book_contact_clear';

export const WAREHOUSE_FETCH_STARTED = 'warehouse_fetch_started';
export const WAREHOUSE_FETCH_SUCCEEDED = 'warehouse_fetch_succeeded';
export const WAREHOUSE_FETCH_FAILED = 'warehouse_fetch_failed';
export const WAREHOUSE_CLEAR = 'warehouse_clear';

export const WAREHOUSES_FETCH_STARTED = 'warehouses_fetch_started';
export const WAREHOUSES_FETCH_SUCCEEDED = 'warehouses_fetch_succeeded';
export const WAREHOUSES_FETCH_FAILED = 'warehouses_fetch_failed';
export const WAREHOUSES_CLEAR = 'warehouses_clear';

export const WAREHOUSES_PAGINATED_FETCH_STARTED = 'warehouses_paginated_fetch_started';
export const WAREHOUSES_PAGINATED_FETCH_SUCCEEDED = 'warehouses_paginated_fetch_succeeded';
export const WAREHOUSES_PAGINATED_FETCH_FAILED = 'warehouses_paginated_fetch_failed';
export const WAREHOUSES_PAGINATED_CHANGE_PAGE = 'warehouses_paginated_change_page';
export const WAREHOUSES_PAGINATED_CLEAR = 'warehouses_paginated_clear';

export const APPLIANCE_PAGINATED_FETCH_STARTED = 'appliance_paginated_fetch_started';
export const APPLIANCE_PAGINATED_FETCH_SUCCEEDED = 'appliance_paginated_fetch_succeeded';
export const APPLIANCE_PAGINATED_FETCH_FAILED = 'appliance_paginated_fetch_failed';
export const APPLIANCE_PAGINATED_CHANGE_PAGE = 'appliance_paginated_change_page';
export const APPLIANCE_PAGINATED_CHANGE_ITEMS_PER_PAGE = 'appliance_paginated_change_items_per_page';
export const APPLIANCE_PAGINATED_CLEAR = 'appliance_paginated_clear';
export const APPLIANCE_PAGINATED_SET_FILTER = 'appliance_paginated_set_filter';

export const APPLIANCE_FILTER_FETCH_STARTED = 'appliance_filter_fetch_started';
export const APPLIANCE_FILTER_FETCH_SUCCEEDED = 'appliance_filter_fetch_succeeded';
export const APPLIANCE_FILTER_FETCH_FAILED = 'appliance_filter_fetch_failed';
export const APPLIANCE_FILTER_SET_FILTER = 'appliance_filter_set_filter';
export const APPLIANCE_FILTER_SELECTED_DATA_FETCH_SUCCEEDED = 'appliance_filter_selected_data_fetch_filter';
export const APPLIANCE_FILTER_CLEAR = 'appliance_filter_clear';

export const FETCH_WAREHOUSE_LOGS = 'fetch_warehouse_logs';
export const FETCH_WAREHOUSE_LOGS_STARTED = 'fetch_warehouse_logs_started';
export const FETCH_WAREHOUSE_LOGS_FAILED = 'fetch_warehouse_logs_failed';
export const WAREHOUSE_LOGS_PAGINATED_CHANGE_PAGE = 'warehouse_logs_paginated_change_page';
export const WAREHOUSE_LOGS_CHANGE_ORDER = 'warehouse_logs_change_order';
export const WAREHOUSE_LOGS_SET_FILTER = 'warehouse_logs_set_filter';
export const WAREHOUSE_LOGS_SET_PERIOD = 'warehouse_logs_set_period';
export const WAREHOUSE_LOGS_CLEAR = 'warehouse_logs_clear';

export const APPLIANCE_FETCH_STARTED = 'appliance_fetch_started';
export const APPLIANCE_FETCH_SUCCEEDED = 'appliance_fetch_succeeded';
export const APPLIANCE_FETCH_FAILED = 'appliance_fetch_failed';
export const APPLIANCE_CLEAR = 'appliance_clear';
export const STOP_APPLIANCE = 'stop_appliance';

export const APPLIANCES_FETCH_STARTED = 'appliances_fetch_started';
export const APPLIANCES_FETCH_SUCCEEDED = 'appliances_fetch_succeeded';
export const APPLIANCES_FETCH_FAILED = 'appliances_fetch_failed';
export const APPLIANCES_CLEAR = 'appliances_clear';
export const APPLIANCE_DEVICES_MERGE_TO_APPLIANCE = 'appliance_devices_merge_to_appliance';

export const FETCH_APPLIANCE_METRICS_BY_IDENTIFIER = 'fetch_appliance_metrics_by_identifier';
export const FETCH_APPLIANCE_METRICS_BY_IDENTIFIER_STARTED = 'fetch_appliance_metrics_by_identifier_started';
export const FETCH_APPLIANCE_METRICS_BY_IDENTIFIER_COMPLETED = 'fetch_appliance_metrics_by_identifier_completed';
export const FETCH_APPLIANCE_LOCATIONS = 'fetch_appliance_locations';
export const FETCH_APPLIANCE_MEASUREMENTS = 'fetch_appliance_measurements';
export const FETCH_APPLIANCE_EVENTS_AND_LOGS_STARTED = 'fetch_appliance_events_and_logs_started';
export const FETCH_APPLIANCE_EVENTS_AND_LOGS = 'fetch_appliance_events_and_logs';
export const UPDATE_APPLIANCE_EVENTS = 'update_appliance_events';

export const APPLIANCE_DEVICES_FETCH_STARTED = 'appliance_devices_fetch_started';
export const APPLIANCE_DEVICES_FETCH_SUCCEEDED = 'appliance_devices_fetch_succeeded';
export const ALL_APPLIANCE_DEVICES_FETCH_SUCCEEDED = 'all_appliance_devices_fetch_succeeded';
export const ALL_APPLIANCE_DEVICES_SOCKET_UPDATE = 'all_appliance_devices_socket_update';
export const APPLIANCE_DEVICES_FETCH_FAILED = 'appliance_devices_fetch_failed';
export const APPLIANCE_DEVICES_CLEAR = 'appliance_devices_clear';

export const LIST_FILTER_DATA_UPDATE = 'list_filter_data_update';
export const LIST_FILTER_DATA_SET = 'list_filter_data_set';
export const LIST_FILTER_STATUS_SET = 'list_filter_status_set';
export const LIST_FILTER_SOURCE_CLEAR = 'list_filter__source_clear';
export const LIST_FILTER_CLEAR = 'list_filter_clear';
export const LIST_FILTER_INITIAL_STATE_SET = 'list_filter_initial_state_set';
export const LIST_FILTER_INITIAL_STATE_UPDATE = 'list_filter_initial_state_update';
export const LIST_FILTER_INITIAL_STATE_CLEAR = 'list_filter_initial_state_clear';
export const LIST_FILTER_PRISTINE_SET = 'list_filter_pristine_set';
export const LIST_FILTER_SET_APPLIED_STATUS = 'list_filter_set_applied_status';

export const AUTH_CHALLENGE_SET = 'auth_challenge_set';
export const AUTH_CHALLENGE_ERROR = 'auth_challenge_error';
export const AUTH_CHALLENGE_CLEAR = 'auth_challenge_clear';
export const AUTH_CHALLENGE_RESEND_CODE_STARTED = 'auth_challenge_resend_code_started';
export const AUTH_CHALLENGE_RESEND_CODE_SUCCEEDED = 'auth_challenge_resend_code_succeeded';
export const AUTH_CHALLENGE_RESEND_CODE_FAILED = 'auth_challenge_resend_code_failed';
export const SET_TABLE_CONFIG = 'set_table_config';
export const UPDATE_TABLE_CONFIG = 'update_table_config';
export const CLEAR_TABLE_CONFIG = 'clear_table_config';

export const FETCH_API_KEYS_REQUEST = 'fetch_api_keys_request';
export const FETCH_API_KEYS_SUCCESS = 'fetch_api_keys_success';
export const FETCH_API_KEYS_FAILURE = 'fetch_api_keys_failure';

export const CREATE_API_KEY_REQUEST = 'create_api_key_request';
export const CREATE_API_KEY_SUCCESS = 'create_api_key_success';
export const CREATE_API_KEY_FAILURE = 'create_api_key_failure';

export const DELETE_API_KEY_REQUEST = 'delete_api_key_request';
export const DELETE_API_KEY_SUCCESS = 'delete_api_key_success';
export const DELETE_API_KEY_FAILURE = 'delete_api_key_failure';

export const RESET_API_KEY_STATE = 'reset_api_key_state';

export const EXCURSION_REPORT_FETCH_STARTED = 'excursion_report_fetch_started';
export const EXCURSION_REPORT_FETCH_SUCCEEDED = 'excursion_report_fetch_succeeded';
export const EXCURSION_REPORT_FETCH_FAILED = 'excursion_report_fetch_failed';
export const EXCURSION_REPORT_CLEAR = 'excursion_report_clear';
